import React from 'react';

import Accordion from 'react-bootstrap/Accordion';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import AdminUserItem from './AdminUserItem';
import AdminCreateUserModal from './AdminCreateUserModal';

class AdminUserAccordion extends React.Component {
    constructor(props) {
	super(props);
	
	this.state = {
	    showCreateUser: false
	};

	this.handleSuccess = this.handleSuccess.bind(this);
	this.handleError = this.handleError.bind(this);
    }

    handleSuccess() {
	this.setState({
	    showCreateUser: false
	});

	this.props.onSuccess();
    }
    
    handleError() {
	this.setState({
	    showCreateUser: false
	});

	this.props.onError();
    }
    
    render() {
	const users = this.props.users;
	
	return (
	    <>
		<br />
		<div className="right">
		    <OverlayTrigger overlay={<Tooltip>L&auml;gg till anv&auml;ndare</Tooltip>}>
			<img src="add_user.png" alt="" className="pointer" onClick={() => this.setState({showCreateUser: true})} />
		    </OverlayTrigger>
		    <OverlayTrigger overlay={<Tooltip>Ladda upp anv&auml;ndare</Tooltip>}>
			<img src="upload.png" alt="" className="pointer" />
		    </OverlayTrigger>
		</div>
		
		<Accordion flush>
		    {users.map(user => (
			<AdminUserItem user={user}
				       key={user.id}
				       token={this.props.token}
				       onSuccess={this.props.onSuccess}
				       onError={this.props.onError}
				       onAuthError={this.props.onAuthError}
			/>
		    ))}
		</Accordion>
		
		<AdminCreateUserModal show={this.state.showCreateUser}
				      token={this.props.token}
				      onHide={() => this.setState({showCreateUser: false})}
				      onSuccess={this.handleSuccess}
				      onError={this.handleError}
				      onAuthError={this.props.onAuthError}
		/>
	    </>
	);
    }
}

export default AdminUserAccordion;
